<div class="lm-grid-card">
  <div class="lm-grid-body">
    <ers-grid
      [columnDefs]="columnDefs"
      [rowData]="rowData"
      [gridOptions]="customGridOptions">
    </ers-grid>
  </div>

  <div class="lm-grid-footer">
    <ers-month-year-picker
      mode="compact"
      [currentMonth]="currentMonth"
      [currentYear]="currentYear"
      (dateChange)="onPickerChange($event)">
    </ers-month-year-picker>

    <div class="lm-footer-stats">
      <div class="lm-stat">
        <span class="stat-label">{{ 'leave_management.employee_leave_balance.total_employee' | transloco }}</span>
        <span class="stat-value">{{ totalEmployees }}</span>
      </div>
      <div class="lm-stat">
        <span class="stat-label">{{ 'leave_management.employee_leave_balance.total_paid_days' | transloco }}</span>
        <span class="stat-value">{{ totalPaidDays }}</span>
      </div>
    </div>
  </div>
</div>
